<div class="panel" style="padding: 1%;">
                                 
    <div class="search-options"
        style="    min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;">
    
    
      <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Customer</span>
            <mat-select id="select-customer" placeholder="Select Customer" [(ngModel)]="selectedCustomer"
                (selectionChange)="loadJobsitesForCustomer(); loadFamiliesForCustomer()" ngDefaultControl  multiple>
                <mat-option [value]="customer.Id" *ngFor="let customer of customerList">
                    {{customer.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field> 
     -->
     <!-- <mat-form-field class="header-form-full-width">
      <span class="label">Customer</span>
      <mat-chip-list #chipList>
        <mat-chip *ngFor="let chip of selectedCustomers" [selectable]="true" [removable]="true"
          (removed)="removeChip(chip)">
          {{ chip }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
  
        <input placeholder="Select Customer" #chipInput [matAutocomplete]="auto" [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addCustomer($event)"
          (input)="filterCustomers($event.target.value)" />
      </mat-chip-list>
      <mat-autocomplete [(ngModel)]="selectCustomer" #auto="matAutocomplete"
        (optionSelected)="onSelectCustomer($event.option)">
        <mat-option [value]="customer.Name" *ngFor="let customer of filteredCustomers ">
          {{ customer.Name }}
        </mat-option>
      </mat-autocomplete>
  
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let customer of filteredCustomers" [value]="customer">
          {{ customer.Name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field> -->
    <mat-form-field class="header-form-full-width">
      <span class="label">{{'Customer' | translate | async}}</span>
      <mat-chip-list #chipList>
        <!-- Display selected customers as chips -->
        <mat-chip *ngFor="let chip of selectedCustomers" [selectable]="true" [removable]="true" (removed)="removeChip(chip)">
          {{ chip.Name }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
    
        <!-- Input field for autocomplete -->
        <input 
          placeholder="{{'Select Customer' | translate | async}}" 
          #chipInput 
          [matAutocomplete]="auto" 
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" 
          (input)="filterCustomers($event.target.value)" 
          name="customer" 
          ngDefaultControl />
      </mat-chip-list>
    
      <!-- Autocomplete dropdown -->
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectCustomer($event)">
        <mat-option *ngFor="let customer of filteredCustomers" [value]="customer.Name">
          {{ customer.Name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
        
    
  
    <!-- <mat-form-field class="header-form-full-width">    
            <span class="label">Family</span>
            <mat-select id="select-family" placeholder="Select Family" [(ngModel)]="selectedFamily"
            (selectionChange)="GetSerialbyModelFamilyMake()" ngDefaultControl  multiple>
                <mat-option [value]="family.Id" *ngFor="let family of familyList">
                 {{family.Title + ' | ' + family.Symbol}} 
                 {{family.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field>  -->   
        <!-- <mat-form-field class="header-form-full-width">
          <span class="label">Family</span>
          <mat-chip-list #FamilychipList>
            <mat-chip *ngFor="let family of selectedFamilies" [selectable]="true" [removable]="true"
              (removed)="removeFamily(family)">
              {{ family }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
      
            <input placeholder="Select Family" #familychipInput [matAutocomplete]="autoFamily" [matChipInputFor]="FamilychipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addFamily($event)"
              (input)="filterFamilies($event.target.value)" />
          </mat-chip-list>
          <mat-autocomplete [(ngModel)]="selectFamily" #autoFamily="matAutocomplete"
            (optionSelected)="selectFamily($event.option)">
            <mat-option [value]="family.Name" *ngFor="let family of filteredFamilies ">
              {{ family.Name }}
            </mat-option>
          </mat-autocomplete>
      
          <mat-autocomplete #autoFamily="matAutocomplete">
            <mat-option *ngFor="let family of filteredFamilies" [value]="family">
              {{ family.Name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field> -->
        <mat-form-field class="header-form-full-width">
          <span class="label">{{'Family' | translate | async}}</span>
          <mat-chip-list #FamilychipList>
            <!-- Display selected families as chips -->
            <mat-chip *ngFor="let family of selectedFamilies" [selectable]="true" [removable]="true" (removed)="removeFamily(family)">
              {{ family.Name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
        
            <!-- Input field for autocomplete -->
            <input 
              placeholder="{{'Select Family' | translate | async}}" 
              #familychipInput 
              [matAutocomplete]="autoFamily" 
              [matChipInputFor]="FamilychipList" 
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" 
              (input)="filterFamilies($event.target.value)" 
              name="family" 
              ngDefaultControl />
          </mat-chip-list>
        
          <!-- Autocomplete dropdown -->
          <mat-autocomplete #autoFamily="matAutocomplete" (optionSelected)="selectFamily($event)">
            <mat-option *ngFor="let family of filteredFamilies" [value]="family.Name">
              {{ family.Name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      

      
          
         <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Implement Type</span>
            <mat-select id="select-implement-type" placeholder="Select Asset/System Type" [(ngModel)]="selectedImplementType"
                style="margin-bottom: 10px;" (selectionChange)="onImplementTypeSelected();onImplementSelected();GetAssetSerialSelectedImplements()" ngDefaultControl  multiple>
                <mat-option [value]="impType.Id" *ngFor="let impType of implementTypeList">
                    {{impType.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field>  -->
        <mat-form-field class="header-form-full-width">
          <span class="label">{{'Implement Type' | translate | async}}</span>
          <mat-chip-list #implementTypeChipList>
            <mat-chip *ngFor="let implementType of selectedImplementTypes" [selectable]="true" [removable]="true"
              (removed)="removeImplementType(implementType)">
              {{ implementType }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input placeholder="{{'Select Asset/System Type' | translate | async}}" #implementTypeInput [matAutocomplete]="autoImplementType"
              [matChipInputFor]="implementTypeChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addImplementType($event)"
              (input)="filterImplementTypes($event.target.value)" />
          </mat-chip-list>
      
      
      
          <mat-autocomplete #autoImplementType="matAutocomplete" (optionSelected)="selectImplementType($event)">
            <mat-option *ngFor="let implementType of filteredImplementTypes" [value]="implementType">
              {{ implementType.Name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
       
        
<!--     
        <mat-form-field class="header-form-full-width">
            <span class="label">Job Site</span>
            <mat-select id="select-jobsite" placeholder="Select Job Site" [(ngModel)]="selectedJobsite"
                (selectionChange)="loadEquipmentForJobsite()" ngDefaultControl  multiple>
                <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
                    {{jobsite.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field> -->
        <mat-form-field class="header-form-full-width">
          <span class="label">{{'Job Site' | translate | async}}</span>
          <mat-chip-list #jobsiteChipList>
            <mat-chip *ngFor="let jobsite of selectedJobsites" [selectable]="true" [removable]="true"
              (removed)="removeJobsite(jobsite)">
              {{ jobsite.Name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input placeholder="{{'Select Job Site' | translate | async}}" #jobsiteInput [matAutocomplete]="autoJobsite"
              [matChipInputFor]="jobsiteChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addJobsite($event)"
              (input)="filterJobsites($event.target.value)" />
          </mat-chip-list>
          <mat-autocomplete #autoJobsite="matAutocomplete" (optionSelected)="selectJobsite($event)">
            <mat-option *ngFor="let jobsite of filteredJobsites" [value]="jobsite">
              {{ jobsite.Name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
         
        <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Make</span>
            <mat-select id="select-make" placeholder="Select Make" [(ngModel)]="selectedMake" (selectionChange)="loadModelList();GetSerialbyModelFamilyMake()"
           ngDefaultControl  multiple>
                <mat-option [value]="make.Id" *ngFor="let make of makeList">
                    {{make.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field> -->
        <mat-form-field class="header-form-full-width">
          <span class="label">{{'Make' | translate | async}}</span>
          <mat-chip-list #makeChipList>
            <!-- Loop through the selectedMakes and display each make as a chip -->
            <mat-chip *ngFor="let make of selectedMakes" [selectable]="true" [removable]="true" (removed)="removeMake(make)">
              {{ make }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
      
            <!-- Input field to filter and add Makes -->
            <input placeholder="{{'Select Make' | translate | async}}" #makeInput [matAutocomplete]="autoMake" [matChipInputFor]="makeChipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="addMake($event)" (input)="filterMakes($event.target.value)" />
          </mat-chip-list>
      
      
          <!-- Auto-complete dropdown for available Makes -->
          <mat-autocomplete #autoMake="matAutocomplete" (optionSelected)="selectMake($event)">
            <mat-option *ngFor="let make of filteredMakes" [value]="make">
              {{ make.Name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      
     

       
    
        <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Component Type</span>
            <mat-select id="select-component-type" placeholder="Select Component Type" [(ngModel)]="selectedComponentType"
                style="margin-bottom: 10px;" (selectionChange)="onComponentTypeSelected()" ngDefaultControl  multiple>
                <mat-option [value]="compType.Id" *ngFor="let compType of componentTypeList">
                    {{compType.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field> -->


        <mat-form-field class="header-form-full-width">
          <span class="label">{{'Component Type' | translate | async}}</span>
      
          <!-- Chip list for selected component types -->
          <mat-chip-list #componentTypeChipList>
            <!-- Loop through selected component types and display them as chips -->
            <mat-chip *ngFor="let compType of selectedComponentTypes" [selectable]="true" [removable]="true"
              (removed)="removeComponentType(compType)">
              {{ compType.Name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
      
            <!-- Input field to filter and add component types -->
            <input placeholder="{{'Select Component Type' | translate | async}}" #componentTypeInput [matAutocomplete]="autoComponentType"
              [matChipInputFor]="componentTypeChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addComponentType($event)"
              (input)="filterComponentTypes($event.target.value)" />
          </mat-chip-list>
      
          <!-- Auto-complete dropdown for available component types -->
          <mat-autocomplete #autoComponentType="matAutocomplete" (optionSelected)="selectComponentType($event)">
            <mat-option *ngFor="let compType of filteredComponentTypes" [value]="compType">
              {{ compType.Name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
    
        <div  class="header-form-full-width">
          <span class="label">{{'Start Date' | translate | async}}</span>
          <mat-form-field>
            <input matInput [matDatepicker]="startDatePicker" placeholder="{{'Start Date'| translate | async}}" [(ngModel)]="startDate"
            ngDefaultControl>
               <!-- [ngModelOptions]="{standalone: true}"  -->
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>       
        </div>
        <!-- <mat-form-field class="header-form-full-width">
            <span class="label">Model</span>
            <mat-select id="select-model" placeholder="Select Model" [(ngModel)]="selectedModel" ngDefaultControl 
            (selectionChange)="GetSerialbyModelFamilyMake()"   multiple>
                <mat-option [value]="model.Id" *ngFor="let model of modelList">
                    {{model.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field> -->
        <mat-form-field class="header-form-full-width">
          <span class="label">{{'Model' | translate | async}}</span>
          <mat-chip-list #modelChipList>
            <!-- Loop through the selected models and display each model as a chip -->
            <mat-chip *ngFor="let model of selectedModels" [selectable]="true" [removable]="true"
              (removed)="removeModel(model)">
              {{ model.Name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
      
            <!-- Input field to filter and add Models -->
            <input placeholder="{{'Select Model' | translate | async}}" #modelInput [matAutocomplete]="autoModel" [matChipInputFor]="modelChipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="addModel($event)" (input)="filterModels($event.target.value)" />
          </mat-chip-list>
      
          <!-- Auto-complete dropdown for available Models -->
          <mat-autocomplete #autoModel="matAutocomplete" (optionSelected)="selectModel($event)">
            <mat-option *ngFor="let model of filteredModels" [value]="model">
              {{ model.Name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
  
        
      
        
    
          <!-- <mat-form-field *ngIf="showMultipleAssetSerial" class="header-form-full-width" style="width: 24%;" >     
            <span class="label">Asset Serial Number</span>
            <mat-select id="select-implement-serial" placeholder="Asset Serial Number" [(ngModel)]="selectedAssetSerial"
                style="margin-bottom: 10px;" (selectionChange)="GetAssetAltForSelectedSerial()"  ngDefaultControl  multiple>
                <mat-option [value]="asset.Id" *ngFor="let asset of AssetSerialList">
                    {{asset.Name}}
                </mat-option>
            </mat-select>
        </mat-form-field> -->
    
        
        <!-- <mat-form-field *ngIf="!showMultipleAssetSerial" class="header-form-full-width" style="width: 24%;">       
            <input  [(ngModel)]="selectedAssetSerial_" type="text" placeholder="Asset Serial Number" id="selectedAssetSerialVal" (input)="changeModelAutoCompleteAssetSerial($event)"   matInput  [matAutocomplete]="auto">
            <mat-autocomplete  (optionSelected)="onSelectAssetSerial_($event.option.value)"    #auto="matAutocomplete" [displayWith]="getTitleAssetSerial.bind(this)"  ngDefaultControl  >
                <mat-option [value]="asset.Id" *ngFor="let asset of AssetSerialList">
                    {{asset.Name}}
                </mat-option>
            </mat-autocomplete>    
          </mat-form-field> -->
          
          


          <!-- <i class="material-icons" (click)="ShowHidefieldAssetSerial()" style="cursor: pointer;">
            find_replace</i>   
           -->
           <mat-form-field class="header-form-full-width" >
            <span class="label">{{'Asset Serial Number' | translate | async}}</span>
            <mat-chip-list #chipListSerial aria-label="Asset Serial Number">
              <mat-chip *ngFor="let asset of selectedAssetSerials" [removable]="true" (removed)="removeAssetSerial(asset)">
                {{ asset.Name }}
                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
              <input 
                placeholder="{{'Select Asset Serial Number' | translate | async}}"
                [matAutocomplete]="autoSerial"
                [matChipInputFor]="chipListSerial"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (input)="filterAssetSerials($event.target.value)"
                (matChipInputTokenEnd)="addAssetSerial($event)" />
            </mat-chip-list>
            <mat-autocomplete #autoSerial="matAutocomplete" (optionSelected)="selectAssetSerial($event)">
              <mat-option *ngFor="let asset of filteredAssetSerials" [value]="asset">
                {{ asset.Name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          
    
    
        <div  class="header-form-full-width">
          <span class="label">End Date</span>
          <mat-form-field>
            <input matInput [matDatepicker]="endDatePicker" placeholder="{{'End Date'|translate|async}}" [(ngModel)]="endDate"
            ngDefaultControl>
                 <!-- [ngModelOptions]="{standalone: true}" -->
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>         
        </div>
        <div class="header-form-full-width" >
    <span class="label">Serial Number</span>
    <mat-form-field>
        <mat-chip-list #serialChipList aria-label="Serial Number">
            <mat-chip *ngFor="let chip of selectedEquipmentList" (removed)="removeEquipment(chip)">
                {{chip.SerialNumber}} : {{chip.UnitNumber}}
                <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip>
            <input
                placeholder="{{'Add Serial Number' | translate | async}}"
                [matAutocomplete]="serialAuto"
                [matChipInputFor]="serialChipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addEquipment($event)">
        </mat-chip-list>
        <mat-autocomplete #serialAuto="matAutocomplete" (optionSelected)="selectEquipment($event)">
            <mat-option *ngFor="let equipment of filteredEquipmentList" [value]="equipment">
                {{equipment.SerialNumber}} : {{equipment.UnitNumber}}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</div>

      
        <!-- <mat-form-field *ngIf="showMultiple" class="header-form-full-width" style="width: 24%;">      
            <span class="label">Serial Number</span>
            <mat-select id="select-equipment-serialno" placeholder="Select Serial Number" [(ngModel)]="selectedEquipment"
                ngDefaultControl  (selectionChange)="onSelectEquipment()" multiple>
                <mat-option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
                    {{equipment.SerialNumber}} : {{equipment.UnitNumber}}
                </mat-option>
            </mat-select>            
        </mat-form-field> -->
       
        <!-- <mat-form-field *ngIf="!showMultiple" class="header-form-full-width" style="width: 24%;">       
            <input [(ngModel)]="selectedEquipment_" type="text" placeholder="{{'Select Serial Number' | translate | async}}" id="selectedEquipmentval" (input)="changeModelAutoComplete($event)"   matInput  [matAutocomplete]="auto">
            <mat-autocomplete  (optionSelected)="onSelectEquipment_($event.option.value)"    #auto="matAutocomplete" [displayWith]="getTitle.bind(this)"  ngDefaultControl  >
                <mat-option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
                    {{equipment.SerialNumber}} : {{equipment.UnitNumber}}
                </mat-option>
            </mat-autocomplete>         
          </mat-form-field>    -->
          <!-- <i class="material-icons" (click)="ShowHidefield()" style="cursor: pointer;">
            find_replace</i>   -->
    
        <mat-form-field  *ngIf="showMultipleAssetAlt" class="header-form-full-width" >   
            <span class="label">{{'Asset Alt. Number' | translate | async}}</span>
            <mat-select id="select-equipment-serialno" placeholder="{{'Asset Alt. Number' | translate | async}}" [(ngModel)]="selectedAssetALT"
                ngDefaultControl  multiple>
                <mat-option [value]="alt.Id" *ngFor="let alt of AssetSerialALTList">
                    {{alt.Name}}
                </mat-option>
            </mat-select>         
        </mat-form-field>
    
        <mat-form-field *ngIf="!showMultipleAssetAlt" class="header-form-full-width" style="width: 24%;">       
            <input [(ngModel)]="selectedAssetAlt_" type="text" placeholder="{{'Asset Alt. Number' | translate | async}}" id="selectedAssetAltval" (input)="changeModelAutoCompleteAssetAlt($event)"   matInput  [matAutocomplete]="auto"  >
            <mat-autocomplete  (optionSelected)="onSelectAssetAlt_($event.option.value)"    #auto="matAutocomplete" [displayWith]="getTitleAssetAlt.bind(this)"   ngDefaultControl >
                <mat-option [value]="alt.Id" *ngFor="let alt of AssetSerialALTList">
                    {{alt.Name}}
                </mat-option>
            </mat-autocomplete>        
          </mat-form-field>   
          <!-- <i class="material-icons" (click)="ShowHidefieldAssetAlt()" style="cursor: pointer;">
            find_replace</i>     -->
    
        <div class="bottom-row">
          <section class="evaluation-middle">
            <span>{{'Evaluation' | translate | async}}</span>
            <mat-checkbox [checked]="EvalA" (change)="getEvalA()" class="evaluation-check-a">
              A
            </mat-checkbox>
            <mat-checkbox [checked]="EvalB" (change)="getEvalB()" class="evaluation-check-b">
              B
            </mat-checkbox>
            <mat-checkbox [checked]="EvalC" (change)="getEvalC()" class="evaluation-check-c">
              C
            </mat-checkbox>
            <mat-checkbox [checked]="EvalX" (change)="getEvalX()" class="evaluation-check-x">
              X
            </mat-checkbox>
          </section>
          <div class="flex flex--align-center">
            <a class="button" (click)="ResetFields();"><span class="button__text">{{'Reset' | translate | async}}</span></a>
            <a class="button button--primary" (click)="submitSelection()">
              <i class="material-icons button__icon">search</i><span class="button__text">{{'Perform Search' | translate | async}}</span>
            </a>
          </div>
        </div>
    
    </div>

  <mat-tab-group *ngIf="(performSearch) && !hidematgroup">
      <mat-tab label="{{'Inspection' | translate | async}}">
              <div id="equipment-implement-list">      
                  <panel class="no-padding table-panel">
                    <div class="spinner" *ngIf="retrievingInspectionResults">
                      <mat-spinner diameter="30"></mat-spinner>
                    </div>
                    <table class="table table--full-width table--striped table--hover table--sortable" style="table-layout: unset;" *ngIf="!retrievingInspectionResults">
                      <thead>
                        <tr>
                          <th (click)="sortBy('Eval')" style="width: 130px;text-align: center">{{'Evaluation' | translate | async}}</th>
                          <th (click)="sortBy('InspectionDate')">{{'Inspection Date' | translate | async}}</th>
                          <th (click)="sortBy('Examiner')">{{'Inspector' | translate | async}}</th>
                          <th (click)="sortBy('SerialNumber')">{{'Serial Number' | translate | async}}</th>
                          <th (click)="sortBy('UnitNumber')">{{'Unit Number' | translate | async}}</th>
                          <th (click)="sortBy('Customer')">{{'Customer' | translate | async}}</th>
                          <th (click)="sortBy('Jobsite')">{{'Job Site' | translate | async}}</th>
                          <th (click)="sortBy('Make')">{{'Make' | translate | async}}</th>
                          <th (click)="sortBy('Model')">{{'Model' | translate | async}}</th>
                          <th (click)="sortBy('Family')">{{'Family' | translate | async}}</th>
                          <th width="50px">{{'Flag' | translate | async}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let inspection of implementInspectionResults">
                          <ng-container *ngIf="!loadingRow">
                            <td class="no-padding" (click)="openInspection(inspection.EquipmentId, inspection.InspectionId)" [@fadeIn]>
                              <span class="eval eval--{{inspection.Evaluation | lowercase}}">{{inspection.Evaluation}}</span>
                            </td>
                            <td (click)="openInspection(inspection.EquipmentId, inspection.InspectionId)" [@fadeIn]>{{inspection.InspectionDate | date:'dd/MMM/yyyy'}}</td>
                            <td (click)="openInspection(inspection.EquipmentId, inspection.InspectionId)" [@fadeIn]>{{inspection.Examiner | aesDecrypt}}</td>
                            <td (click)="openInspection(inspection.EquipmentId, inspection.InspectionId)" [@fadeIn]>{{inspection.SerialNumber}}</td>
                            <td (click)="openInspection(inspection.EquipmentId, inspection.InspectionId)" [@fadeIn]>{{inspection.UnitNumber}}</td>
                            <td (click)="openInspection(inspection.EquipmentId, inspection.InspectionId)" [@fadeIn]>{{inspection.CustomerName}}</td>
                            <td (click)="openInspection(inspection.EquipmentId, inspection.InspectionId)" [@fadeIn]>{{inspection.JobsiteName}}</td>
                            <td (click)="openInspection(inspection.EquipmentId, inspection.InspectionId)" [@fadeIn]>{{inspection.Make}}</td>
                            <td (click)="openInspection(inspection.EquipmentId, inspection.InspectionId)" [@fadeIn]>{{inspection.Model}}</td>
                            <td (click)="openInspection(inspection.EquipmentId, inspection.InspectionId)" [@fadeIn]>{{inspection.Family}}</td>
                            <td (click)="openInspection(inspection.EquipmentId, inspection.InspectionId)"  [style.padding]="inspection.InspectionFlag != 0 ? '0' : null">

                                <ng-container>
                                    <div class="customWidthClass" > </div>
                                    <div class="customWidthClass">
                                        <div style="display: flex;">
                          
                                            <div class="menutoggle" *ngIf="inspection.InspectionFlag !=0" (click)="OpenInspectionPage(inspection.EquipmentId, inspection.InspectionId)">
                                              
                                              <i  class="material-icons button__icon"
                                              style="font-size: 35px; vertical-align: middle;margin-top: -13%; cursor: context-menu; color: red;"
                                                    title="Click to Open Inspection Page">flag</i>
                                                    <span class="badge">{{inspection.InspectionFlag}}</span> 
                                            </div>
                          
                                        </div>
                          
                          
                                    </div>
                                </ng-container>



                            </td>
                          </ng-container>
                          <ng-container *ngIf="loadingRow">
                            <td colspan="10">
                              <div class="ph-item" style="height: 33px;">
                                <div class="ph-row">
                                  <div class="ph-col-12"></div>
                                </div>
                              </div>
                            </td>
                          </ng-container>
                        </tr>                       
                      </tbody>
                    </table>
                    <mat-paginator [pageIndex]="pageNumber" [length]="totalResults" [pageSize]="inspectionsPerPage" [pageSizeOptions]="[5, 10, 25, 100]"
                      (page)="onPageEvent($event)">
                    </mat-paginator>
                  </panel>


              </div>
      </mat-tab>

  </mat-tab-group>
</div>

<div class="emptyscreen" *ngIf="!performSearch || hidematgroup ">{{'Please use the Search field above to select what inspection you are shown.' | translate | async}}</div>
